import React, { useEffect, useRef } from 'react'
import AgGridTable from 'src/components/AgGridTable'
import ExternalActionsTable from 'src/components/ExternalActionsTable';
import { autoSizeColumns, getColorCellValid } from 'src/util/functions';

const columnDef = [
  { headerName: 'CODIGO MERCADO', field: 'CODIGO_MERCADO', minWidth: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'NOMBRE MERCADO', field: 'NOMBRE_MERCADO', minWidth: 200, resizable: true, sortable: true, filter: true },
  { headerName: 'CODIGO CATEGORIA', field: 'CODIGO_CATEGORIA', minWidth: 150, resizable: true, sortable: true, filter: true},
  { headerName: 'TIPO REGISTRO', field: 'TIPO_REGISTRO', minWidth: 150, resizable: true, sortable: true, filter: true },
  { headerName: 'ESTADO', field: 'msg', minWidth: 300, resizable: true, sortable: true, filter: true},
  { headerName: 'FILA', field: 'fila', minWidth: 150, resizable: true, sortable: true, filter: true}
];

const TableExcelMercado = ({properties}) => {
  const { data } = properties;

  //* Referencias
  const tableRef = useRef(null);
  const validRef = useRef(null);
  const errorRef = useRef(null);

  //* Effects
  useEffect(() => {
    validRef.current.innerText = data.countValid;
    errorRef.current.innerText = data.countError;
  }, [])

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mx-4 mb-2'>
        <div className='d-flex align-items-center justify-content-start'>
          <div className='d-flex align-items-center'>
            <strong style={{fontSize: '16px'}}>Validos: </strong>
            <span className='ml-1' ref={validRef} style={{fontSize: '20px', color: '#64DF38', fontWeight: 'bold'}}> 0</span>
          </div>  
          <div className='d-flex align-items-center ml-4'>
            <strong style={{fontSize: '16px'}}>Errores: </strong>
            <span className='ml-1' ref={errorRef} style={{fontSize: '20px', color: 'red', fontWeight: 'bold'}}> 0</span>
          </div>
        </div>
        <ExternalActionsTable accionExcel={{
          tableRef: tableRef,
          fileName: 'Registros Mercados'
        }}/>
      </div>
      <AgGridTable
        columnDef={columnDef}
        referencia={tableRef}
        dataList={data.data || []}
        onGridReady={(params) => autoSizeColumns(params)}
        getRowStyle={getColorCellValid}
        height='55vh'

      />
    </>
  )
}

export default TableExcelMercado